"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _common = require("./utils/common");
var _fetch = _interopRequireDefault(require("./utils/fetch"));
var _logger = _interopRequireDefault(require("./utils/logger"));
/**
 * 本地hmr的管理对象
 */
var HmrManage = /*#__PURE__*/function () {
  function HmrManage() {
    (0, _classCallCheck2["default"])(this, HmrManage);
    // 是否hmr调试中
    this.debug = false;
    // hmr调试默认端口
    this.port = '9000';
  }

  /**
   * 组件hmr的启动
   * @param awaitPromises
   * @param port
   */
  return (0, _createClass2["default"])(HmrManage, [{
    key: "hmrStart",
    value: function hmrStart(moduleManage, awaitPromises, port) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.debug) {
        return;
      }
      this.debug = true;
      this.port = port;
      this.moduleManage = moduleManage;
      this.onLoadError = opts.onLoadError;
      this.protocol = window.CLI_SETTING && window.CLI_SETTING.https ? 'https:' : 'http:';
      return this.loadHmrComp(awaitPromises, opts);
    }

    /**
     * 获取hmr本地文件的有效地址
     * @param {*} compKey
     */
  }, {
    key: "getHmrUrl",
    value: function getHmrUrl(compKey) {
      return "".concat(this.protocol, "//localhost:").concat(this.port, "/components/").concat(compKey, "/index.js");
    }

    /**
     * hmr启动并等待本地的相关js文件加载完成
     * @param awaitPromises
     */
  }, {
    key: "loadHmrComp",
    value: (function () {
      var _loadHmrComp = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this = this;
        var awaitPromises,
          opts,
          hmrUrlObj,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              awaitPromises = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
              opts = _args.length > 1 ? _args[1] : undefined;
              _context.prev = 2;
              _context.next = 5;
              return (0, _common.allSettled)(awaitPromises.concat([this.getHmrCompObjs()]));
            case 5:
              if (!(!this.hmrCompObjs || this.hmrCompObjs.length === 0)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              // 总的hmr入口文件会调用setHmrCompKey，告知有哪几个hmr的组件;
              hmrUrlObj = {};
              this.hmrCompObjs.forEach(function (compObj) {
                hmrUrlObj[compObj.compKey] = _this.getHmrUrl(compObj.compDir);
              });
              // hmr组件也走标准的组件模块化
              this.moduleManage.setHmrUrlObj(hmrUrlObj);
              _context.next = 12;
              return this.moduleManage.initCompsByCompKeys(Object.keys(hmrUrlObj), opts);
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);
              _logger["default"].error('%c wujiComp Hmr failed!', 'color: red;', _context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 14]]);
      }));
      function loadHmrComp() {
        return _loadHmrComp.apply(this, arguments);
      }
      return loadHmrComp;
    }()
    /**
     * 获取要hmr的组件信息集
     */
    )
  }, {
    key: "getHmrCompObjs",
    value: (function () {
      var _getHmrCompObjs = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var result, _this$onLoadError;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _fetch["default"])("".concat(this.protocol, "//localhost:").concat(this.port, "/api/comp"), {
                method: 'GET',
                credentials: 'omit'
              });
            case 3:
              result = _context2.sent;
              if (result && result.code === 200) {
                this.hmrCompObjs = result.data || [];
              }
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              _logger["default"].error(_context2.t0);
              (_this$onLoadError = this.onLoadError) === null || _this$onLoadError === void 0 ? void 0 : _this$onLoadError.call(this);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function getHmrCompObjs() {
        return _getHmrCompObjs.apply(this, arguments);
      }
      return getHmrCompObjs;
    }())
  }]);
}();
var _default = exports["default"] = HmrManage;